import { render, staticRenderFns } from "./materialPagePartner.vue?vue&type=template&id=6b90ed00&scoped=true"
import script from "./materialPagePartner.vue?vue&type=script&lang=js"
export * from "./materialPagePartner.vue?vue&type=script&lang=js"
import style0 from "./materialPagePartner.vue?vue&type=style&index=0&id=6b90ed00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90ed00",
  null
  
)

export default component.exports